import React, { useEffect, useRef } from 'react'
import { useSearchParams } from 'react-router-dom'

interface FilterProps {
    updateFilters: (filterName: string, newValue: string, shouldDelete?: boolean) => void
}

export const InvoiceFilters = (props: FilterProps) => {
    const { updateFilters } = props
    const [searchParams, setSearchParams] = useSearchParams()
    const initializedRef = useRef(false)

    const urlCompleted = searchParams.get('completed')

    useEffect(() => {
        if (!initializedRef.current) {
            initializedRef.current = true

            if (urlCompleted && urlCompleted !== '-1') {
                updateFilters('completed', urlCompleted, false)
            }
        }
    }, [updateFilters, urlCompleted])

    const handleCompletedChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const value = e.target.value
        const nextSearchParams = new URLSearchParams(searchParams)

        if (value === '-1') {
            nextSearchParams.delete('completed')
        } else {
            nextSearchParams.set('completed', value)
        }

        if (nextSearchParams.toString() !== searchParams.toString()) {
            setSearchParams(nextSearchParams)
        }

        updateFilters('completed', value, value === '-1')
    }

    return (
        <>
        <label htmlFor='completedFilter'>Completed</label>
        <select
            className='form-select'
            id='completedFilter'
            value={urlCompleted || '-1'}
            onChange={handleCompletedChange}>
            <option value={'-1'}>All</option>
            <option value={'0'}>No</option>
            <option value={'1'}>Yes</option>
        </select>
        </>
    )
}
